export default {
    beforeMount(el) {
        el.style.textAlign = 'right';

        const sanitizeTyping = (value) => {
            if (!value) return '';

            value = String(value).replace(/[^\d.,]/g, '');

            const lastComma = value.lastIndexOf(',');
            const lastDot = value.lastIndexOf('.');
            const lastSep = Math.max(lastComma, lastDot);

            if (lastSep >= 0) {
                const intPart = value
                    .slice(0, lastSep)
                    .replace(/[.,]/g, '');

                const decPart = value
                    .slice(lastSep + 1)
                    .replace(/[.,]/g, '')
                    .slice(0, 2);

                return intPart + ',' + decPart;
            }

            return value.replace(/[.,]/g, '');
        };

        const parsePtBrToNumber = (value) => {
            if (value === null || value === undefined) return null;

            let v = String(value).trim();
            if (!v) return null;

            v = v.replace(/\./g, '').replace(',', '.');

            const n = Number(v);
            return isNaN(n) ? null : n;
        };

        const formatPtBr = (value) => {
            const n = parsePtBrToNumber(value);
            if (n === null) return '';

            return n.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        };

        const onInput = (e) => {
            const original = e.target.value;
            const sanitized = sanitizeTyping(original);

            if (original !== sanitized) {
                const pos = e.target.selectionStart ?? sanitized.length;
                e.target.value = sanitized;

                requestAnimationFrame(() => {
                    const newPos = Math.min(pos, sanitized.length);
                    if (typeof e.target.setSelectionRange === 'function') {
                        e.target.setSelectionRange(newPos, newPos);
                    }
                });
            }
        };

        const onFocus = (e) => {
            let value = e.target.value?.trim();
            if (!value) return;

            // 1.234,56 -> 1234,56
            e.target.value = value.replace(/\./g, '');
        };

        const onBlur = (e) => {
            e.target.value = formatPtBr(e.target.value);

            // dispara input apenas no blur para atualizar o v-model com valor formatado
            e.target.dispatchEvent(new Event('input', { bubbles: true }));
        };

        const onKeyDown = (e) => {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
            ];

            if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
                return;
            }

            if (!/[\d.,]/.test(e.key)) {
                e.preventDefault();
            }
        };

        el._decimalMaskHandlers = { onInput, onFocus, onBlur, onKeyDown };

        el.addEventListener('input', onInput);
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', onBlur);
        el.addEventListener('keydown', onKeyDown);
    },

    mounted(el) {
        if (el.value !== undefined && el.value !== null && el.value !== '') {
            let value = String(el.value).trim();

            value = value.replace(/\./g, '').replace(',', '.');

            const n = Number(value);
            if (!isNaN(n)) {
                el.value = n.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
        }
    },

    unmounted(el) {
        if (el._decimalMaskHandlers) {
            el.removeEventListener('input', el._decimalMaskHandlers.onInput);
            el.removeEventListener('focus', el._decimalMaskHandlers.onFocus);
            el.removeEventListener('blur', el._decimalMaskHandlers.onBlur);
            el.removeEventListener('keydown', el._decimalMaskHandlers.onKeyDown);
            delete el._decimalMaskHandlers;
        }
    }
};